import { connect } from 'react-redux';
import { actions } from '../../../../../../redux/modules/investments/investments';
import InvestmentsSummary from "./SummaryInvestments";


const ms2p = (state) => {
  return {
    ...state.investments,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(InvestmentsSummary);
